import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useModalData } from '../../../components/modals/ModalsContext'
import { useOpenEditServiceOrderModal } from '../../../utils/routes/modals/modalsActions'
import Button from '../../../packages/kiti/components/actions/Button'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const id = useModalData()
  const canCreateActionPlan = useSessionPermission('createServiceOrder')
  const openCreateServiceOrderModal = useOpenEditServiceOrderModal()

  return (
    <>
      <Grid justify="flex-start" align="center" gutter={0.3}>
        <Col flex={1}>
          <Title size="h4" color="dark1" noMargin>
            Planos de ação
          </Title>
        </Col>

        <Col flex={1}></Col>

        {canCreateActionPlan && (
          <Col>
            <Button
              onClick={() => openCreateServiceOrderModal({ initialState: { formReplyId: id } })}
              size="small"
              transparent
            >
              Criar plano de ação
            </Button>
          </Col>
        )}
      </Grid>

      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
